import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

export const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.enumeration<
    graphql.schema.SpaceWarningCode,
    ents.extra.space.Warning.Code
  >({
    [graphql.schema.SpaceWarningCode
      .ExclusiveFunctionsForNonExclusiveMethodology]:
      ents.extra.space.Warning.Code
        .ExclusiveFunctionsForNonExclusiveMethodology,
    [graphql.schema.SpaceWarningCode
      .InvalidFunctionalizationsForExclusiveMethodology]:
      ents.extra.space.Warning.Code
        .InvalidFunctionalizationsForExclusiveMethodology,
    [graphql.schema.SpaceWarningCode.FunctionalUsageNotFullyCoded]:
      ents.extra.space.Warning.Code.FunctionalUsageNotFullyCoded,
    [graphql.schema.SpaceWarningCode
      .MissingFunctionalUsagesForSelectedAccounts]:
      ents.extra.space.Warning.Code.MissingFunctionalUsagesForSelectedAccounts,
    [graphql.schema.SpaceWarningCode
      .MissingSponsoredAccountsForSponsoredFunctionalUsages]:
      ents.extra.space.Warning.Code
        .MissingSponsoredAccountsForSponsoredFunctionalUsages,
  }),
)
